import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.scss'
})
export class CheckboxComponent {
  @Input() control!: FormControl;
  @Input() submitted: boolean = false;
  @Input() items: any[] = [];
  @Input() labelProperty: string = "label";
  @Input() valueProperty: string = "value";
  @Input() errorMessage: string = "";
  @Output() checkedChange = new EventEmitter<any[]>();

  onCheckboxChange(event: any, item: any) {
    const isChecked = event.target.checked as HTMLInputElement; // Cast to HTMLInputElement
    item.isChecked = isChecked;
    const selectedValues = this.items.filter(i => i.isChecked).map(i => i[this.valueProperty]);
    this.control.setValue(selectedValues);
    this.checkedChange.emit(selectedValues);
  }
}
